import _ from 'lodash';
import Submission from 'edge/quoteandbind/common/models/Submission';
import conditionalProductFlow from 'integration/quoteandbind/config/ConditionalProductFlow';

export default (
    $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx,
    $stateParams, StateUtils, ActionMessageUtil, AgeAllowedToDrive, MaximumAge, QuickQuoteService, EventHub, QuoteJumpToStepService
) => {

    const ACTIONS = {
        proceedToFullQuote: (model) => {
            if (!model.submission) {
                return $q.reject();
            }
            const productCode = model.submission.baseData.productCode.value;
            conditionalProductFlow.fullQuoteFlowDefn(
                model.submission, productCode, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService,
                ViewModelCtx, $stateParams, ActionMessageUtil, EventHub, QuoteJumpToStepService
            );

            // doesn't matter what we return here as long as it's a promise, starting a new wizard flow moves to a new page
            return $q.resolve();
        },

        getQuickQuote: (model) => {
            const quotingModel = _.cloneDeep(model.value);
            if (model.submission) {
                quotingModel.submissionNumber = model.submission.quoteID.value;
            }
            model.quotingPromise = QuickQuoteService.createSubmission(quotingModel).then(submissionDTO => {
                let quotedSubmission = submissionDTO;
                quotedSubmission.bindData = undefined;
                quotedSubmission = new Submission(quotedSubmission);
                model.submission = ViewModelService.create(quotedSubmission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
                return model;
            });
            return model.quotingPromise;
        }
    };

    return function (step, junction) {
        step('vehicle', true)
            .onNext.goTo('address')
            .isValid(model => model.lobCoverables.aspects.valid && model.lobCoverables.aspects.subtreeValid);

        step('address')
            .onNext.goTo('driver')
            .isValid(model => model.policyAddress.aspects.valid
                && model.policyAddress.aspects.subtreeValid
                && model.policyAddress.value !== ''
                && model.policyAddress.value !== undefined);

        step('driver')
            .onNext.doAction(ACTIONS.getQuickQuote).thenGoTo('estimate', 'quickQuoteError')
            .isValid(model => model.age.aspects.valid
                && model.age.aspects.subtreeValid
                && model.age.value >= AgeAllowedToDrive
                && model.age.value <= MaximumAge
                && model.termsChecked.value === true);

        step('estimate')
            .onNext.branch(model => {
                if (model && model.resetToStart) {
                    return 'vehicle';
                }
                return 'preProceedToFull';
            })
            .isValid(model => {
                if (model && model.resetToStart) {
                    return true;
                }
                return model.aspects.valid && model.aspects.subtreeValid;
            });

        junction('preProceedToFull')
            .onNext.doAction(ACTIONS.proceedToFullQuote)
            .thenGoTo('exit', 'quickQuoteError');

        junction('exit');

        step('quickQuoteError');

    };
};
